import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { ProfileSidebar } from "@/components/talent/ProfileSidebar";
import { DetailCard, EducationCard, PricingCard, TopicsCard } from "@/components/talent/DetailCards";
import { ScheduleCard } from "@/components/talent/ScheduleCard";
import { ReviewsCard } from "@/components/talent/ReviewsCard";

export default function TalentDetail() {
  const { id } = useParams();
  const [t, setT] = useState(null);
  const [services, setServices] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/talents/${id}`).then((r) => setT(r.data)).catch(() => setError("Talent tidak ditemukan"));
    api.get("/services").then((r) => setServices(r.data));
  }, [id]);

  if (error) return <div className="max-w-3xl mx-auto px-4 py-24 text-center text-slate-500">{error}</div>;
  if (!t) return <div className="max-w-3xl mx-auto px-4 py-24 text-center text-slate-500">Memuat...</div>;

  const offered = services.filter((s) => t.service_ids.includes(s.id));

  return (
    <div className="ib bg-white">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 py-6 sm:py-10">
        <Link to="/talent" className="inline-flex items-center gap-2 text-sm font-medium text-[#053B5D] hover:underline mb-5" data-testid="back-to-talents"><ArrowLeft size={16} strokeWidth={2} />Semua talent</Link>
        <div className="grid gap-6 md:grid-cols-[280px_1fr] items-start">
          <ProfileSidebar t={t} />
          <div className="space-y-6 min-w-0">
            <DetailCard t={t} />
            <div className="grid gap-6 lg:grid-cols-2">
              <EducationCard education={t.education} />
              <TopicsCard skills={t.skills} />
            </div>
            <PricingCard offered={offered} />
            {offered.length > 0 && <ScheduleCard t={t} offered={offered} />}
            <ReviewsCard reviews={t.reviews} />
          </div>
        </div>
      </div>
    </div>
  );
}
